<template>
  <div>
    <b-modal ref="modal" title="Receber Contas" header-class="border-bottom-0" footer-class="border-top-0" size="xl"
      no-close-on-backdrop>
      <!-- heading  -->
      <div>
        <div class="row grid-table-heading d-none d-md-flex">
          <span class="col-md-4" style="color: red"><b>Débitos</b></span>
          <div class="col-md-8 d-flex" style="padding: 0px">
            <div class="col-2 text-right">Saldo devedor</div>
            <div class="col-2 text-right">Receber</div>
            <div class="col-2 text-right">Desconto</div>
            <div class="col-2 text-right">Acréscimo</div>
            <div class="col-2 text-right">Juros</div>
            <div class="col-2 text-right">Valor a Pagar</div>
          </div>
        </div>
        <hr />

        <!-- bills  -->
        <template v-for="(billForm, index) in billsForm">
          <div class="row align-items-center" :key="index">
            <!-- fist column  -->
            <div class="col-md-4 mb-3 mb-md-0">
              {{ billForm.name }}
              <br />
              <small class="text-muted">Documento: {{ billForm.document }}</small>
            </div>

            <!-- secont column  -->
            <div class="col-md-8">
              <div class="row">
                <!-- saldo devedor -->
                <div class="col-6 d-block d-md-none">
                  <small>Saldo devedor:</small>
                </div>
                <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2 text-right">
                  <number-input :formGroupClass="'mb-0'" :value="billForm.ramainder_value"
                    :disabled="true"></number-input>
                </div>

                <!-- saldo devedor -->
                <div class="col-6 d-block d-md-none">
                  <small>Pagamento:</small>
                </div>
                <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2">
                  <number-input :formGroupClass="'mb-0'" v-model="billForm.received_value"></number-input>
                </div>

                <!-- desconto -->
                <div class="col-6 d-block d-md-none">
                  <small>Desconto:</small>
                </div>
                <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2 text-right">
                  <number-input :formGroupClass="'mb-0'" v-model="billForm.discount"></number-input>
                </div>

                <!-- acrescimo -->
                <div class="col-6 d-block d-md-none">
                  <small>Acrescimo:</small>
                </div>
                <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2">
                  <number-input :formGroupClass="'mb-0'" v-model="billForm.addition"></number-input>
                </div>

                <!-- juros -->
                <div class="col-6 d-block d-md-none">
                  <small>Juros:</small>
                </div>
                <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2">
                  <number-input :formGroupClass="'mb-0'" v-model="billForm.interest"></number-input>
                </div>

                <!-- valor a pagar -->
                <div class="col-6 d-block d-md-none">
                  <small>Valor a pagar:</small>
                </div>

                <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2 pr-md-3">
                  <number-input :formGroupClass="'mb-0'" :value="billForm.received_value -
                    billForm.discount +
                    billForm.addition +
                    billForm.interest
                    " :disabled="true" />
                </div>
              </div>

              <!-- second row -->
              <div>
                <template v-if="billForm.received_value < billForm.ramainder_value">
                  <div class="text-right" :key="'alert' + index">
                    <small class="text-info">Ficará restando um saldo devedor de
                      {{
                        (billForm.ramainder_value - billForm.received_value)
                        | decimal
                      }}
                      para está conta.</small>
                  </div>
                </template>
                <template v-if="billForm.received_value > billForm.ramainder_value">
                  <div class="text-right" :key="'alert2' + index">
                    <small class="text-danger">Impossivel pagar um valor maior que o saldo
                      devedor.</small>
                  </div>
                </template>
              </div>
            </div>
          </div>



          <hr :key="'hr' + index" />
        </template>

        <template v-if="hasCredits">
          <br />
          <br />
          <span style="color: green"> <b>Créditos</b></span>
          <template v-for="(billForm, index) in creditsForm">
            <div class="row" :key="index">
              <div class="col-md-4 mb-3 mb-md-0">
                {{ billForm.name }}
                <br />
                <small class="text-muted">Documento: {{ billForm.document }}</small>
              </div>
              <div class="col-md-8">
                <div class="row">
                  <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2">
                    <div class="col-6 d-block">
                      <small>Saldo:</small>
                    </div>
                    <number-input :formGroupClass="'mb-0'" v-model="billForm.ramainder_value"
                      :disabled="true"></number-input>
                  </div>
                  <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2">
                    <div class="col-6 d-block"></div>
                  </div>

                  <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2">
                    <div class="col-6 d-block"></div>
                  </div>

                  <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2">
                    <div class="col-6 d-block"></div>
                  </div>

                  <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2">
                    <div class="col-6 d-block"></div>
                  </div>

                  <div class="col-6 col-md-2 mb-md-0 mb-2 p-md-2">
                    <div class="col-6 d-block">
                      <small>Utilizar:</small>
                    </div>
                    <number-input :formGroupClass="'mb-0'" v-model="billForm.received_value"></number-input>
                  </div>
                </div>
              </div>
            </div>
            <hr :key="'hr' + index" />
          </template>
        </template>

        <br />
        <div class="row">
          <div class="col-md-4 offset-md-8">
            <div class="row mb-2">
              <div class="col-8">Total do Pagamento:</div>
              <div class="col-4 text-right">
                {{ sum_received_value | decimal }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-8">Total desconto:</div>
              <div class="col-4 text-right">{{ sum_discount | decimal }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-8">Total Acrescimo:</div>
              <div class="col-4 text-right">{{ sum_addition | decimal }}</div>
            </div>

            <div class="row mb-2">
              <div class="col-8">Total Juros:</div>
              <div class="col-4 text-right">
                {{ sum_interest | decimal }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-8">Créditos:</div>
              <div class="col-4 text-right">
                {{ sum_credit_received_value | decimal }}
              </div>
            </div>
            <hr class="mt-1 mb-1" />
            <div class="row mb-2">
              <div class="col-8">
                <b>Total a pagar:</b>
              </div>
              <div class="col-4 text-right">
                <b class="text-danger">{{
                  sum_net_received_value | decimal
                  }}</b>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12">
                <select-input :options="paymentOptions" v-model="payment_method" alias="Forma de Pagamento" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <account-select-input @input="setAccount($event)" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <error-handler :error="error" />

      <div slot="modal-footer">
        <button role="button" class="btn btn-outline-secondary" @click="$refs.modal.hide()">
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button role="button" class="btn btn-success" style="margin-left: 5px" @click="store()">
          <i class="fas fa-check"></i> Receber
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import AccountSelectInput from "../../account/inputs/AccountSelectInput.vue";

export default {
  components: { AccountSelectInput },
  data: function () {
    return {
      account_id: null,

      bills: {},

      billsForm: [],

      credits: {},

      creditsForm: [],

      error: null,

      paymentOptions: {
        1: "Dinheiro",

        2: "Cheque",

        3: "Cartão de Crédito",

        4: "Cartão de Débito",

        15: "Boleto Bancário",

        16: "Depósito Bancário",

        17: "PIX",

        18: "Carteira Digital",

        99: "Outros",
      },

      payment_method: 1,
    };
  },

  async created() {
    await this.$store.dispatch("account/getAccounts", { status: 1 });
  },

  computed: {
    accounts() {
      let accounts = {};
      for (let index in this.$store.state.account.accounts) {
        accounts[
          this.$store.state.account.accounts[index].id
        ] = this.$store.state.account.accounts[index].description;
      }
      return accounts;
    },

    sum_received_value() {
      return this.billsForm.reduce((sum, row) => sum + row.received_value, 0); // todo arredondar
    },

    sum_discount() {
      return this.billsForm.reduce((sum, row) => sum + row.discount, 0);
    },

    sum_addition() {
      return this.billsForm.reduce((sum, row) => sum + row.addition, 0);
    },

    sum_interest() {
      return this.billsForm.reduce((sum, row) => sum + row.interest, 0);
    },

    sum_net_received_value() {
      return (
        this.sum_received_value -
        this.sum_discount +
        this.sum_addition +
        this.sum_interest -
        this.sum_credit_received_value
      );
    },

    hasCredits() {
      return this.creditsForm.length > 0;
    },

    sum_credit_received_value() {
      return this.creditsForm.reduce((sum, row) => sum + row.received_value, 0);
    },

    interestFactor() {
      if (this.$store.state.company.bill_interest_calculation_method == "s") {
        return parseFloat(this.$store.state.company.bill_interest_rate / 100);
      } else {
        return parseFloat(
          Math.pow(
            this.$store.state.company.bill_interest_rate / 100 + 1,
            1 / 30
          )
        );
      }
    },

    interest() {
      return this.selected.reduce((total, row) => {
        if (row.over_due_days > 0) {
          if (
            this.$store.state.company.bill_interest_calculation_method == "s"
          ) {
            return (
              total +
              ((row.value * this.interestFactor) / 30) * row.over_due_days
            );
          } else {
            return (
              total +
              row.value * (Math.pow(this.interestFactor, row.over_due_days) - 1)
            );
          }
        }
        return 0;
      }, 0);
    },
  },

  methods: {
    open(data) {
      this.accounts;

      this.payment_method = 1
      //this.bills = bills;

      this.setBills(data);

      this.setBillsFormData(this.bills);

      this.setCreditsFormData(this.credits);

      this.$refs.modal.show();
    },

    setBills(bills) {
      this.bills = bills.filter((row) => this.isBillDebt(row));

      this.credits = bills.filter((row) => !this.isBillDebt(row));
    },

    isBillDebt(bill) {
      return bill.value > 0;
    },

    setAccounts(accounts) {
      for (let index in accounts) {
        this.accounts[accounts[index].id] = accounts[index].description;
      }
    },

    setBillsFormData(bills) {
      this.billsForm = [];

      console.log(bills);

      for (let index in bills) {
        let billForm = this.getBillFormData(bills[index]);

        this.$set(this.billsForm, index, billForm);
      }
    },

    getBillFormData(bill) {
      let billForm = {};

      billForm.id = bill.id;
      billForm.document = bill.document;
      billForm.value = bill.value;
      billForm.ramainder_value = bill.value - bill.received_value;
      billForm.discount = 0;
      billForm.addition = 0;
      billForm.interest = this.getInterest(bill);
      billForm.received_value = billForm.ramainder_value;

      return billForm;
    },

    getStoreParams() {
      let params = {
        account_id: this.account_id,
        bills: this.billsForm,
        credits: this.creditsForm,
        payment_method: this.payment_method,
      };

      for (let index in params.credits) {
        params.credits[index].value = params.credits[index].value * -1;
        params.credits[index].received_value =
          params.credits[index].received_value * -1;
      }

      return params;
    },

    store() {
      this.$store.commit("showLoading");
      axios
        .post("api/receivebillreceiveble/store", this.getStoreParams())
        .then((response) => {
          this.$emit("received");

          this.$store.commit("showAlert", {
            message: "Recebimento efetuado com sucesso.",
            type: "success",
          });

          this.$refs.modal.hide();
        })
        .catch((error) => {
          this.$store.commit("hideLoading");

          this.error = error;
        });
    },

    setCreditsFormData(credits) {
      this.creditsForm = [];

      for (let index in credits) {
        let billForm = this.getCreditFormData(credits[index]);
        this.$set(this.creditsForm, index, billForm);
      }
    },

    getCreditFormData(bill) {
      let billForm = {};

      billForm.id = bill.id;
      billForm.document = bill.document;
      billForm.value = bill.value * -1;
      billForm.ramainder_value = (bill.value - bill.received_value) * -1;
      billForm.discount = 0;
      billForm.addition = 0;
      billForm.interest = 0;
      billForm.received_value = billForm.ramainder_value;

      return billForm;
    },

    getInterest(bill) {
      let days = moment().diff(moment(bill.due_date, "YYYY-MM-DD"), "days");

      if (days < 0) {
        return 0;
      }

      if (this.$store.state.company.bill_interest_calculation_method == "s") {
        return (
          (((bill.value - bill.received_value) * this.interestFactor) / 30) *
          days
        );
      } else {
        return (
          (bill.value - bill.received_value) *
          (Math.pow(this.interestFactor, days) - 1)
        );
      }
    },
    setAccount(account) {
      this.account_id = account.id;
    }
  },
};
</script>
